import { css } from 'styled-components';
import { setCssVar } from './cssVar';
import greyscale from './grey';
const brand = {
    black: '#000000',
    grey: greyscale,
    paleGreen: '#F4FCF3',
    lightGreen: '#EAFAE9',
    lightBeige: '#F0EEE6',
    green: '#3CD52F',
    greenGrey: '#75786D',
    paleBurgundy: '#E9D5D8',
    lightBurgundy: '#CF9EA4',
    burgundy: '#76232F',
    white: '#fff',
    validation: {
        invalid: '#da291c',
        valid: '#008c15',
    },
};
export const beigeTheme = css `
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('bgColor', brand.lightBeige)};
  ${setCssVar('bgColorAlt', brand.lightBeige)};
  ${setCssVar('accentColor', brand.green)};
  ${setCssVar('accentColorAlt', brand.green)};
`;
export const darkTheme = css `
  ${setCssVar('fgColor', brand.white)};
  ${setCssVar('bgColor', brand.black)};
  ${setCssVar('bgColorAlt', brand.black)};
  ${setCssVar('accentColor', brand.green)};
  ${setCssVar('accentColorAlt', brand.green)};
`;
export const lightTheme = css `
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('bgColor', brand.white)};
  ${setCssVar('bgColorAlt', brand.white)};
  ${setCssVar('accentColor', brand.green)};
  ${setCssVar('accentColorAlt', brand.green)};
`;
export const lightGreenTheme = css `
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('bgColor', brand.lightGreen)};
  ${setCssVar('bgColorAlt', brand.paleGreen)};
  ${setCssVar('accentColor', brand.green)};
  ${setCssVar('accentColorAlt', brand.green)};
`;
export const beigeBurgundyTheme = css `
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('bgColor', brand.lightBeige)};
  ${setCssVar('bgColorAlt', brand.lightBeige)};
  ${setCssVar('accentColor', brand.burgundy)};
  ${setCssVar('accentColorAlt', brand.burgundy)};
`;
export const darkBurgundyTheme = css `
  ${setCssVar('fgColor', brand.white)};
  ${setCssVar('bgColor', brand.black)};
  ${setCssVar('bgColorAlt', brand.black)};
  ${setCssVar('accentColor', brand.lightBurgundy)};
  ${setCssVar('accentColorAlt', brand.lightBurgundy)};
`;
export const whiteBurgundyTheme = css `
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('bgColor', brand.white)};
  ${setCssVar('bgColorAlt', brand.white)};
  ${setCssVar('accentColor', brand.burgundy)};
  ${setCssVar('accentColorAlt', brand.burgundy)};
`;
export const burgundyTheme = css `
  ${setCssVar('fgColor', brand.white)};
  ${setCssVar('bgColor', brand.burgundy)};
  ${setCssVar('bgColorAlt', brand.burgundy)};
  ${setCssVar('accentColor', brand.white)};
  ${setCssVar('accentColorAlt', brand.white)};
`;
export const themes = {
    beige: beigeTheme,
    dark: darkTheme,
    light: lightTheme,
    lightGreen: lightGreenTheme,
    beigeBurgundy: beigeBurgundyTheme,
    darkBurgundy: darkBurgundyTheme,
    whiteBurgundy: whiteBurgundyTheme,
    burgundy: burgundyTheme,
};
export default brand;
